var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14286 8C1.14286 8.31557 0.887 8.57143 0.571429 8.57143C0.255857 8.57143 0 8.31557 0 8C0 3.58871 3.58871 0 8 0C10.1987 0 12.2331 0.876143 13.7143 2.38471V0.571429C13.7143 0.255857 13.9701 0 14.2857 0C14.6013 0 14.8571 0.255857 14.8571 0.571429V4C14.8571 4.31557 14.6013 4.57143 14.2857 4.57143H10.8571C10.5416 4.57143 10.2857 4.31557 10.2857 4C10.2857 3.68443 10.5416 3.42857 10.8571 3.42857H13.1297C11.8476 1.98629 10.0031 1.14286 8 1.14286C4.219 1.14286 1.14286 4.219 1.14286 8ZM15.4286 7.42857C15.113 7.42857 14.8571 7.68443 14.8571 8C14.8571 11.781 11.781 14.8571 8 14.8571C5.99686 14.8571 4.15243 14.0137 2.87029 12.5714H5.14286C5.45843 12.5714 5.71429 12.3156 5.71429 12C5.71429 11.6844 5.45843 11.4286 5.14286 11.4286H1.71429C1.39871 11.4286 1.14286 11.6844 1.14286 12V15.4286C1.14286 15.7441 1.39871 16 1.71429 16C2.02986 16 2.28571 15.7441 2.28571 15.4286V13.6153C3.76686 15.1239 5.80129 16 8 16C12.4113 16 16 12.4113 16 8C16 7.68443 15.7441 7.42857 15.4286 7.42857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/Sync.908fdcf1fc5a441763263e154c8eaca8.svg";
export { ForwardRef as ReactComponent };